import differenceInSeconds from 'date-fns/differenceInSeconds'

/**
 * returns the number of seconds between now and the date passed in
 * @param date - The date to compare against Date.now() in either a Date or UTC string format
 */
function getSecondsRemaining (date: number, dateToCompare?: number): number;
function getSecondsRemaining (date: string, dateToCompare?: number): number;
function getSecondsRemaining (date: Date, dateToCompare?: number): number;
function getSecondsRemaining (date: string | Date | number, dateToCompare = Date.now()): number {

  if (typeof date === 'string') {

    return differenceInSeconds(new Date(date).getTime(), dateToCompare)

  }
  if (typeof date === 'number') {

    return differenceInSeconds(date, dateToCompare)

  }
  else {

    return differenceInSeconds(date, dateToCompare)

  }

}

export default getSecondsRemaining
